import React from "react";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, wide = false }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto p-4 sm:p-8" data-testid="admin-modal">
      <div className="fixed inset-0 bg-ink/50" onClick={onClose} />
      <div className={`relative bg-white rounded-xl shadow-2xl w-full ${wide ? "max-w-3xl" : "max-w-xl"} my-8`}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <h3 className="font-serif text-xl font-semibold text-ink">{title}</h3>
          <button onClick={onClose} className="p-1.5 rounded-md text-ink-muted hover:bg-gray-100 transition-colors" data-testid="modal-close-btn">
            <X size={18} />
          </button>
        </div>
        <div className="px-6 py-5">{children}</div>
      </div>
    </div>
  );
}
